if (!customElements.get('faq-section')) {
    customElements.define('faq-section', class FaqSection extends HTMLElement {
        constructor() {
            super();
            this.questions = this.querySelectorAll('.faq-content__question');
            this.initEvents();
        }

        initEvents(){
            this.questions.forEach( question => question.onclick = () => this.onQuestionOpen(question) );
        }
    
        onQuestionOpen(question){
            const answer = question.nextElementSibling;
            if(answer.style.maxHeight){
                answer.style.maxHeight = null;
                question.classList.remove('is_open');
            }else{
                this.questions.forEach((q) => {
                    q.classList.remove('is_open');
                    q.nextElementSibling.style.maxHeight = null
                })
                question.classList.add('is_open');
                answer.style.maxHeight = answer.scrollHeight + 'px'
            }
        }

        slideDown(element){
            element.style.height = "auto";
            var height = element.clientHeight + "px";
            element.style.height = "0px";
            setTimeout(() => {
                element.style.height = height
            }, 0)
        }
        slideUp(element){
            element.style.height = "0px"
        }
    });
}